import React from 'react'

export default function LoadingCard() {
  return (
    <div className="flex flex-col items-center justify-center bg-white rounded-lg min-h-[220px] shadow-lg w-full">
      <div className="spinner"></div>
    </div>
  )
}
